import React from 'react';
import { GlobalContext } from '../../store/GlobalContext';

const useModalConfirmacao = () => {
  const { setModalData } = React.useContext(GlobalContext);

  function abreModalConfirmacao(texto, acaoConfirmacao) {
    setModalData({ texto, visible: true, acaoConfirmacao });
  }

  return { abreModalConfirmacao };
};

export default useModalConfirmacao;
